import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SiteArmScheduleComponent } from './site-arm-schedule.component';
import { WarningModule } from '../../../modals/warning/warning.module';
import { SharedModule } from '../../../directives/shared.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WarningModule,
    SharedModule
  ],
  declarations: [SiteArmScheduleComponent],
  exports: [SiteArmScheduleComponent] 
})
export class SiteArmSchduleModule { }
